import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ 'report', 'request', 'assign'];

  assign(event) {
    event.preventDefault();

    let assigned = false;
    this.reportTargets.forEach((el) => {
      const checkbox = el.querySelector('input[type="checkbox"]');
      if (!checkbox) {
        return;
      }

      if (checkbox.checked) {
        el.classList.add('assigned');
        el.querySelector('input[type="hidden"]').value = checkbox.value;
        assigned = true
      } else {
        el.classList.remove('assigned');
        el.querySelector('input[type="hidden"]').value = '';
      }
    });

    if (assigned) {
      this.reportTargets.forEach((el) => {
        const checkbox = el.querySelector('input[type="checkbox"]')
        if (checkbox) {
          checkbox.disabled = true;
        }
      });
      this.assignTarget.classList.add('hidden');
      this.requestTarget.disabled = false;
    }
  }
}
